import React, { Component } from 'react';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import NoAppointmentsFound from '../common/NoDataFound';
import { Pagination } from './../common/Pagination';
import { PATH } from '../../../utils/Constants';
import { paginationCount } from '../../../utils/URL';
// import profileImg from "../../../utils/images/profileImg.png";
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { getStudentInformation } from '../../action/educator/AdminModuleAction';
import { validateSearchNameInput } from '../../../utils/Utility';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

class MyStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            isLoading: true,
            todosPerPage: paginationCount,
            studentList: [],
            data: {},
            totalPages: 0,
            searchValue: '',
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    //componentDidMount
    componentDidMount() {
        this.getStudentInformation(
            this.state.searchValue,
            this.state.currentPage,
            this.state.todosPerPage
        );
    }

    //getStudentInformation
    getStudentInformation(search, pageNumber, itemsPerPage) {
        const values = {
            id: '',
            search,
            pageNumber: pageNumber + 1,
            itemsPerPage: itemsPerPage,
        };
        this.props.getStudentInformation(values, (result) => {
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    studentList: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                    isLoading: false,
                });
            } else {
                this.setState({ studentList: [], isLoading: false, totalPages: 0 });
            }
        });
    }

    /**
     * Loading
     */
    isLoading() {
        this.setState((prevState) => ({
            isLoading: !prevState.isLoading,
        }));
    }

    //handlePageChange
    handlePageChange(event) {
        // myLog(event);
        this.setState(
            {
                currentPage: Number(event.selected),
                isLoading: true,
                offSetValue: Number(event.selected) * this.state.todosPerPage,
            },
            this.getStudentInformation(
                this.state.searchValue,
                Number(event.selected),
                this.state.todosPerPage
            )
        );
    }

    /**
     * Handle Search Users
     * @param {Event} event
     */
    handleSearchUser = (event) => {
        const searchValue = event.target.value;
        if (validateSearchNameInput(searchValue) || searchValue === '') {
            this.setState({ searchValue });
            clearTimeout(this.state.timeout);
            const timeout = setTimeout(() => {
                this.isLoading();
                this.getStudentInformation(searchValue, 0, this.state.todosPerPage);
            }, 1000); // 1Sec delay before triggering the search
            this.setState({ timeout });
        }
    };

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    render() {
        let pageDisplayCount = this.state.totalPages;
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.MY_STUDENTS}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={this.props.t('teamMembers')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-4xl font-medium text-white">
                                {this.props.t('teamMembers')}
                            </h6>
                            <div className="relative gap-4 mt-4 sm:flex lg:w-1/4 sm:mt-0">
                                <input
                                    type="text"
                                    className="block w-full rounded bg-schedule py-1.5 pl-3 pr-10 text-white placeholder:text-secondary sm:text-base"
                                    placeholder={this.props.t('searchTeamMembersName')}
                                    onChange={this.handleSearchUser}
                                    value={this.state.searchValue}
                                    autoComplete="off"
                                    maxLength={50}
                                />
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="absolute transform -translate-y-1/2 pointer-events-none right-3 top-1/2"
                                >
                                    <path
                                        d="M7.66665 13.9997C11.1644 13.9997 14 11.1641 14 7.66634C14 4.16854 11.1644 1.33301 7.66665 1.33301C4.16884 1.33301 1.33331 4.16854 1.33331 7.66634C1.33331 11.1641 4.16884 13.9997 7.66665 13.9997Z"
                                        stroke="#10DACE"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M14.6666 14.6663L13.3333 13.333"
                                        stroke="#10DACE"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                {this.state.studentList.length > 0 ? (
                                    <div className="items-center justify-between px-4 pt-6 sm:flex sm:px-8">
                                        <div className="w-full h-auto p-6 rounded-lg bg-card">
                                            {this.state.studentList.map((session, index) => (
                                                <div
                                                    key={index}
                                                    className={`sm:flex justify-between gap-x-6 ${
                                                        this.state.studentList.length === index + 1
                                                            ? ''
                                                            : 'mb-6'
                                                    }`}
                                                >
                                                    <div className="flex items-center mb-5 gap-x-4 sm:mb-0">
                                                        {/* {session.image ? (
                              <img
                                className="flex-none rounded-full sm:w-16 sm:h-16 w-9 h-9 bg-gray-50"
                                src={session.image}
                                alt=""
                              />
                            ) : (
                              <img
                                className="flex-none rounded-full sm:w-16 sm:h-16 w-9 h-9 bg-gray-50"
                                src={profileImg}
                                alt=""
                              />
                            )} */}
                                                        <span
                                                            className="text-lg text-white"
                                                            title={session?.name}
                                                        >
                                                            {session?.name &&
                                                            session.name.length > 40
                                                                ? `${session.name.slice(0, 40)}...`
                                                                : session.name}
                                                        </span>
                                                    </div>
                                                    <div className="flex flex-col justify-center sm:items-end">
                                                        <button
                                                            type="button"
                                                            className="cursor-pointer inline-flex justify-center text-base rounded-lg font-medium lg:px-4 px-3 py-1.5 bg-UIprimary text-white sm:w-full"
                                                            onClick={() => {
                                                                this.props.history.push(
                                                                    `${PATH.IM_PHYSICIAN.SUMMARY}/${this.props.match.params.userId}/${session?.id}`
                                                                );
                                                            }}
                                                        >
                                                            {this.props.t('viewSummary')}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="p-6">
                                        <NoAppointmentsFound isFrom={'Team Members'} />
                                    </div>
                                )}
                            </>
                        )}
                        <div className="flex items-center justify-end gap-2 px-4 mt-4 -space-x-px sm:px-8">
                            {pageDisplayCount > 1 && (
                                <Pagination
                                    currentPage={this.state.currentPage}
                                    pageDisplayCount={pageDisplayCount}
                                    onPageChange={this.handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getStudentInformation: (values, callBack) => {
            dispatch(getStudentInformation(values, callBack));
        },
    };
};

const ConnectedMyStudents = withLanguage(connect(null, mapDispatchToProps)(MyStudents));

export default (props) => (
    <LanguageProvider>
        <ConnectedMyStudents {...props} />
    </LanguageProvider>
);
